import { InputLabel, MenuItem, Select } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";

const DateTimeDropDown = ({ setDateTime }) => {
  const today = moment().format("DD/MM/YYYY");
  const tomorrow = moment().add(1, "days").format("DD/MM/YYYY");
  const dayAfter = moment().add(2, "days").format("DD/MM/YYYY");

  const dates = [today, tomorrow, dayAfter];

  const [date, setDate] = useState(today); // Default to today
  const [times, setTimes] = useState([]);
  const [selectedTime, setSelectedTime] = useState(8); // Default to 8 AM

  useEffect(() => {
    const timesArray = [];
    for (let i = 8; i <= 18; i++) {
      const displayHour = i % 12 || 12;
      const suffix = i < 12 ? " AM" : " PM";
      timesArray.push({ key: i, value: `${displayHour}${suffix}` });
    }
    setTimes(timesArray);

    // Set default full datetime
    updateDateTime(today, 8);
  }, []);

  const updateDateTime = (selectedDate, selectedHour) => {
    const formattedDate = moment(selectedDate, "DD/MM/YYYY").format(
      "YYYY-MM-DD"
    );
    const dateTimeString = `${formattedDate} ${selectedHour}:00:00`;
    const formattedDateTime = moment(
      dateTimeString,
      "YYYY-MM-DD HH:mm:ss"
    ).format("YYYY-MM-DD HH:mm:ss.SSS");
    setDateTime(formattedDateTime);
  };

  return (
    <div className="flex flex-row gap-4">
      <div>
        <InputLabel id="date-label">Date</InputLabel>
        <Select
          labelId="date-select-label"
          id="date-select"
          value={date}
          onChange={(e) => {
            setDate(e.target.value);
            updateDateTime(e.target.value, selectedTime);
          }}
          fullWidth
        >
          {dates.map((dateOption, i) => (
            <MenuItem key={i} value={dateOption}>
              {dateOption}
            </MenuItem>
          ))}
        </Select>
      </div>
      <div>
        <InputLabel id="time-label">Time</InputLabel>
        <Select
          labelId="time-select-label"
          id="time-select"
          value={selectedTime}
          onChange={(e) => {
            setSelectedTime(e.target.value);
            updateDateTime(date, e.target.value);
          }}
          fullWidth
        >
          {times.map((time) => (
            <MenuItem key={time.key} value={time.key}>
              {time.value}
            </MenuItem>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default DateTimeDropDown;
